// extracted by mini-css-extract-plugin
module.exports = {"counting-box":"zdxP1N1iG3Qw8QK7M4eR4","wrapper":"_2D22HoAZE99VWhK1OlcIXv","receipt":"JYSRZWbsRgoi16iuHd0sz"};